import { media } from "../../design/breakpoints";
import React from "react";
import styled from "styled-components";
import { LinkedinIcon } from "../../assets/icons";
import { IoLogoInstagram } from "react-icons/io";

const Container = styled.footer`
  background: linear-gradient(135deg, var(--secondary), #e8f0ff);
  font-size: 0.6rem;
  border-radius: 30px;
  margin: 1rem auto;
  width: 80%;
  display: flex;
  flex-direction: row;          /* always row */
  justify-content: space-between; 
  align-items: center;
  padding: 0.6rem 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  gap: 12px;                    /* spacing between 3 sections */
  flex-wrap: nowrap;            /* prevent stacking */

  /* Slightly smaller font on small screens */
  ${media.max768} {
    font-size: 0.5rem;
    gap: 6px;
  }

  ${media.max480} {
    font-size: 0.45rem;
    gap: 6px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.12);
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 6px;          /* spacing inside each section */
    white-space: nowrap; /* prevent text breaking */
  }

  @media (min-width: 61.313em) {
    font-size: 0.8rem;
    padding: 0.5rem 2rem;
  }
`;

const IconWrapper = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;

  svg {
    width: 22px;
    height: 22px;
  }

  /* 🔥 Smaller icons on mobile */
  ${media.max768} {
    width: 20px;
    height: 20px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  ${media.max480} {
    width: 18px;
    height: 18px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;


const FooterLink = styled.a`
  color: inherit;
  text-decoration: none;
  position: relative;
  transition: color 0.3s ease;

  ${media.max768} {
    margin: 0.2rem;
  }

  ${media.max480} {
    margin: 0.1rem; 
  }

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -2px;
    left: 50%;
    background-color: var(--primary);
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover {
    color: var(--primary);

    &::after {
      width: 100%;
    }

    svg {
      fill: var(--primary);
    }

    ${IconWrapper} {
      transform: translateY(-3px) scale(1.1);
    }
  }
`;


export default function Footer() {
  return (
    <Container>
      <div style={{ display: "flex", gap: "4px" }}>
        <div>© {new Date().getFullYear()} Vaaripa Innovations. </div>
        <div>| All Rights Reserved</div>
      </div>
      <div>
        {/* <FooterLink
          href="https://federate.one/privacy-policy"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </FooterLink> */}
      </div>
      <div style={{ display: "flex", gap: "2px" }}>
        <FooterLink
          href={"https://www.linkedin.com/company/vaaripa/"}
          target="_blank"
          rel="noreferrer"
        >
          <IconWrapper>
            <LinkedinIcon />
          </IconWrapper>
        </FooterLink>
        <FooterLink
          href={"https://www.instagram.com/vaaripa.smart?igsh=bnZ2ZnU1N28xajZ1"}
          target="_blank"
          rel="noreferrer"
        >
          <IconWrapper>
            <IoLogoInstagram color="#1E1E1E" />
          </IconWrapper>
        </FooterLink>
      </div>
    </Container>
  );
}